import { HomeTemplate } from "./HomeTemplate";

export const IndexPageEn: React.FC = () => {
  return (
    <div id="__nuxt">
      <div id="__layout">
        <div data-v-1dfadbfa="" className="container2">
          <div data-v-0a8cdf28="" data-v-1dfadbfa="" className="form-messages">
            <div
              data-v-0a8cdf28=""
              className="notifications"
              style={{ width: "380px", top: "0px", left: "calc(50% - 190px)" }}
            >
              <span></span>
            </div>
            <div
              data-v-0a8cdf28=""
              className="notifications"
              style={{ width: "380px", top: "0px", left: "calc(50% - 190px)" }}
            >
              <span></span>
            </div>
          </div>
          <div data-v-1dfadbfa="" className="StudioCanvas">
            <span className="modals"></span>
            <div tabIndex={0} data-s-66e5ee07-e9fb-47f8-96c6-d2ee282a96e5="" className="sd">
              <article data-s-774b1e76-89a6-44c3-b26c-2bc45e2396a9="" className="sd">
                <div data-s-a2cc7bbd-b798-4d10-abc2-8092c15bdafd="" className="sd">
                  <div
                    data-s-81d72478-6840-44d4-8143-b996fc5ae106=""
                    data-r-0_0_0_81d72478-6840-44d4-8143-b996fc5ae106=""
                    className="image sd"
                  ></div>
                  <div data-s-da89ac69-fa05-4cc5-9a01-05ceef59e79d="" className="sd">
                    <p
                      data-s-1b2155b6-6d5d-412a-84b9-21e2b0f4a35d=""
                      data-r-0_1_0_0_1b2155b6-6d5d-412a-84b9-21e2b0f4a35d=""
                      className="text sd"
                    >
                      SCROLL
                    </p>
                    <div data-s-5b279e6e-cd22-44ab-a4c0-1398da6a9c22="" className="sd"></div>
                  </div>
                  <div data-s-6315ce7e-b3a3-4785-8a0e-42ead94f73ec="" className="sd">
                    <h1
                      data-s-9831d52f-f5ef-4d19-9227-5da719cc8c2e=""
                      data-r-0_2_0_0_9831d52f-f5ef-4d19-9227-5da719cc8c2e=""
                      className="text sd"
                    >
                      SAKUTARO
                      <br />
                      Poem NFT
                      <br />
                    </h1>
                    <p
                      data-s-2cd1c004-6400-4af7-9137-1b02abfba3ec=""
                      data-r-1_2_0_0_2cd1c004-6400-4af7-9137-1b02abfba3ec=""
                      className="text sd"
                    >
                      Poem × Full-on-chain NFT
                    </p>
                  </div>
                </div>
                <section data-s-c1e98b4f-f96f-4a42-bc21-402c96aa7572="" className="sd">
                  <article data-s-c6d730d3-becd-40ed-b6dc-c759fd4e4a5a="" className="sd">
                    <h2
                      data-s-51bba351-bf95-46fd-aa58-9fd8d79c5506=""
                      data-r-0_0_1_0_51bba351-bf95-46fd-aa58-9fd8d79c5506=""
                      className="text sd"
                    >
                      ABOUT
                    </h2>
                    <p
                      data-s-aa52a276-9fe0-4e88-aed7-3a25a9eca265=""
                      data-r-1_0_1_0_aa52a276-9fe0-4e88-aed7-3a25a9eca265=""
                      className="text sd"
                    >
                      Thirty-nine poems from Sakutaro Hagiwara's late self-selected collection "Shukumei" have been
                      inscribed on the blockchain as full-on-chain NFTs. These NFTs have a little mysterious property in
                      that their contents change depending on the owner.
                    </p>
                  </article>
                </section>
                <section data-s-0e0df88b-d577-4025-9253-07371aaea8b4="" className="sd">
                  <div
                    data-s-ecb07cf3-bde9-4092-b6f6-57b53da809e3=""
                    data-r-0_2_0_ecb07cf3-bde9-4092-b6f6-57b53da809e3=""
                    className="image sd"
                  >
                    <div id="box_menue" data-s-f4fadec5-b28b-4fa3-9d9a-294b57753a7a="" className="sd">
                      <div data-s-fd403487-f510-4def-b134-a27b0234bb77="" className="sd">
                        <h2
                          data-s-b551b4af-0c34-42df-9704-b72489e11c3f=""
                          data-r-0_0_0_0_2_0_b551b4af-0c34-42df-9704-b72489e11c3f=""
                          className="text sd"
                        >
                          CHAINS
                          <br />
                        </h2>
                        <p
                          id="p_menue"
                          data-s-17d873bf-d093-4bc0-81d7-565651fb4f87=""
                          data-r-1_0_0_0_2_0_17d873bf-d093-4bc0-81d7-565651fb4f87=""
                          className="text sd"
                        >
                          These NFTs will be issued on multiple blockchains.
                          <br />
                          NFTs can be issued on chains such as Ethereum, Polygon, BSC, Arbitrum, Optimism, Shiden,
                          Avalanche C-Chain, Flow, Tezos, Sui, Aptos, etc. (to be supported in due course). Up to 39 NFTs can be
                          issued for each chain.
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
                <section data-s-ddaec6b9-dbcd-4a77-a1d7-f82df5490657="" className="sd">
                  <article data-s-42de091b-5fac-45f1-a048-a014a789abd3="" className="sd">
                    <h2
                      data-s-b795887e-b59e-4247-9911-149343a1c8a5=""
                      data-r-0_0_3_0_b795887e-b59e-4247-9911-149343a1c8a5=""
                      className="text sd"
                    >
                      MOTIVATION
                    </h2>
                    <p
                      data-s-5ef25f9f-0f8b-4a30-9994-72cb43c4a47e=""
                      data-r-1_0_3_0_5ef25f9f-0f8b-4a30-9994-72cb43c4a47e=""
                      className="text sd"
                    >
                      I like the literary works of Sakutaro Hagiwara.
                      <br />
                      What can we do to add value to this and keep it in the digital space for a long time?
                      <br />
                      How enduring are the NFT standards and SVG data? Which chains should be used to ensure that they
                      remain in place for a long time? This is an experiment that will be conducted many years into the
                      future.
                    </p>
                  </article>
                </section>
                <section id="contents" data-s-3efd6a44-a543-478e-911c-f1d8b6289260="" className="sd">
                  <article data-s-a0cddf43-9931-499e-9fb5-c89162569b2b="" className="sd">
                    <h2
                      data-s-1d90a504-ae4f-458f-9016-08bcad48e989=""
                      data-r-0_0_4_0_1d90a504-ae4f-458f-9016-08bcad48e989=""
                      className="text sd"
                    >
                      CONTENTS
                    </h2>
                    <div data-s-c6b997e9-78d4-4884-b7bc-3ea6f762d54c="" className="sd">
                      <div data-s-36b29a60-5085-43d1-8474-c430b34b9580="" className="sd">
                        <img
                          data-s-2ecf162d-2631-465f-9b20-5f982daf8018=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_0dfbf5ec-e130-44f4-884a-2b4b9f9438be_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-4b15ed2b-c7f1-455e-a039-f959ba64e35c=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_8b38e7c7-a084-424d-82cb-cd120c451c8d_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-8cde5ab0-1434-4fef-9091-76b1c147e169=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_4a1035b6-6799-4c9f-be63-a3764c96c89a_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-fd391e78-fd6d-4556-bb62-51aef5b0ecff=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_e962b4a1-774e-4213-8669-46d2fdb69360_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-4efd44c4-719c-498e-b943-ab4996bf3dd5=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_475f9333-9a52-41d5-a973-6e78910f944a_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-db559559-c87d-4495-99e8-3c97c1e2ec58=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_5eba3afc-6e31-4dbd-ae09-c90ea6be13ae_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-93886f1c-5b77-4395-b43c-e8634ecf0f49=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_c0e4fc72-1ee1-42cb-bd42-c7991c87e2bd_small.webp"
                          className="sd"
                        />
                        <img
                          data-s-cf9e58fc-77cf-4fbb-a86f-ac158b05b8c9=""
                          alt=""
                          src="/assets/s-1024x1024_v-fs_webp_3834921f-236a-437c-894a-56a8f4e5804b_small.webp"
                          className="sd"
                        />
                      </div>
                      <p
                        data-s-2123616b-55dc-49b7-bd77-1c3731c01fa6=""
                        data-r-1_1_0_4_0_2123616b-55dc-49b7-bd77-1c3731c01fa6=""
                        className="text sd"
                      >
                        and more...
                      </p>
                    </div>
                  </article>
                </section>
                <section id="structure" data-s-3efd6a44-a543-478e-911c-f1d8b6289260="" className="sd">
                  <article data-s-a0cddf43-9931-499e-9fb5-c89162569b2b="" className="sd">
                    <h2
                      data-s-1d90a504-ae4f-458f-9016-08bcad48e989=""
                      data-r-0_0_4_0_1d90a504-ae4f-458f-9016-08bcad48e989=""
                      className="text sd"
                    >
                      STRUCTURE
                    </h2>
                    <p
                      data-s-5ef25f9f-0f8b-4a30-9994-72cb43c4a47e=""
                      data-r-1_0_3_0_5ef25f9f-0f8b-4a30-9994-72cb43c4a47e=""
                      className="text sd"
                    >
                      All metadata, including images, are stored on-chain.
                      <br />
                      The owner's address will determine which poem it will be.
                    </p>
                    <div data-s-36b29a60-5085-43d1-8474-c430b34b9580="" className="sd">
                      <img alt="" src="/assets/nft-overview.png" className="sd" />
                    </div>
                  </article>
                </section>
                <section data-s-c7ea60d5-cff9-4cbc-9aef-2339d3ee6e04="" className="sd">
                  <article data-s-bda20a08-406f-4881-8ddd-97f2c1a20853="" className="sd">
                    <h2
                      data-s-5195d6e6-609f-49c5-ac2d-fe958ab7d567=""
                      data-r-0_0_5_0_5195d6e6-609f-49c5-ac2d-fe958ab7d567=""
                      className="text sd"
                    >
                      MINT
                    </h2>
                    <p
                      data-s-e5ab817d-bb18-4ec4-99ce-69d4333df84e=""
                      data-r-1_0_5_0_e5ab817d-bb18-4ec4-99ce-69d4333df84e=""
                      className="text sd"
                    >
                      The issuance of NFTs is free of charge (Gas fee will be charged). Please limit the number of NFTs
                      per person per chain.
                      <br />
                      There are some chains for which NFT viewers do not yet exist. Please be aware of this.
                    </p>
                  </article>
                </section>
                <div data-s-1a539230-bffa-4cf1-b28c-520a2872663e="" className="frame sd">
                  <HomeTemplate />
                </div>
                <div data-s-200fa833-6c62-490f-841b-5f0c5e90249c="" className="sd">
                  <div data-s-c822dec2-f5d8-4ad8-ad9a-552d4c117608="" className="sd">
                    <div data-s-b2dd7be8-e847-4e26-ba87-3a152131ccc9="" className="sd">
                      <i data-s-8e58c82c-18ac-42a8-8aed-9b43a09e5bfc="" className="icon fa fa-quote-left sd"></i>
                      <p
                        data-s-14a3d823-dc22-4533-9f39-f76faf67b609=""
                        data-r-1_0_0_7_0_14a3d823-dc22-4533-9f39-f76faf67b609=""
                        className="text sd"
                      >
                        詩の表現の目的は単に情調のための情調を表現することではない。
                        <br />
                        <br />
                        幻覚のための幻覚を描くことでもない。
                        <br />
                        <br />
                        同時にまたある種の思想を宣伝演繹することのためでもない。
                        <br />
                        <br />
                        詩の本来の目的は寧ろそれらの者を通じて、人心の内部に顫動する所の感情そのものの本質を凝視し、かつ感情をさかんに流露させることである。
                        <br />
                        <br />
                        詩とは感情の神経を掴んだものである。生きて働く心理学である。
                        <br />
                      </p>
                    </div>
                    <div data-s-ce83b52c-936c-4294-bb33-73d5d2d82f25="" className="sd">
                      <p
                        data-s-fa7deea5-0461-40a9-a81b-440f5df83dfa=""
                        data-r-0_1_0_7_0_fa7deea5-0461-40a9-a81b-440f5df83dfa=""
                        className="text sd"
                      >
                        ― 萩原 朔太郎
                      </p>
                    </div>
                  </div>
                </div>
                <footer data-s-244d4441-fc95-40b5-8cd4-9064fd018c5b="" className="sd">
                  <div data-s-15826f2f-cde2-4dcd-9c87-bb40d2677007="" className="sd">
                    <div data-s-2a1f73d5-1b23-4f35-970f-bc7a8a95759d="" className="sd">
                      <div data-s-9ce91408-c130-427b-a96d-5c191753efc9="" className="sd">
                        <h1
                          data-s-8df2c4ed-8a7d-4568-b87d-64c45f8bbf83=""
                          data-r-0_0_0_0_8_0_8df2c4ed-8a7d-4568-b87d-64c45f8bbf83=""
                          className="text sd"
                        >
                          SAKUTARO
                          <br />
                        </h1>
                      </div>
                    </div>
                    <h1
                      data-s-185ddd13-e094-4afd-8305-39ed0d895816=""
                      data-r-1_0_8_0_185ddd13-e094-4afd-8305-39ed0d895816=""
                      className="text sd"
                    >
                      Poem NFT
                      <br />
                    </h1>
                    <div data-s-4e263ea3-b6dc-4fa8-be26-d6c758411bd9="" className="sd">
                      <div data-s-2e1a129f-ac90-4969-82c9-7b8b3eb3e89d="" className="sd">
                        <div data-s-954995ba-03f4-437e-9af7-b317ffae1e1c="" className="sd">
                          <div data-s-602eceea-5e07-4eb5-8c93-7095e3075e20="" className="sd">
                            <div data-s-d9111423-1a1f-4560-a8ad-2fc2c9c5fcae="" className="sd">
                              <a target="_blank" href="https://twitter.com/arandoros" rel="noreferrer">
                                <p
                                  data-s-06d1fee6-0add-4293-8c06-e5d7a7446f13=""
                                  data-r-0_0_0_0_0_2_0_8_0_06d1fee6-0add-4293-8c06-e5d7a7446f13=""
                                  className="text sd"
                                >
                                  Created by Ara @arandoros
                                </p>
                              </a>
                            </div>
                          </div>
                          <a
                            target="_blank"
                            href="https://twitter.com/arandoros"
                            rel="noopener noreferrer"
                            data-s-218d2ad5-a96d-478b-b0fe-9a5139386091=""
                            className="icon fa fa-twitter sd"
                          >
                            {""}
                          </a>
                        </div>
                      </div>
                    </div>

                    <div data-s-4e263ea3-b6dc-4fa8-be26-d6c758411bd9="" className="sd">
                      <div data-s-2e1a129f-ac90-4969-82c9-7b8b3eb3e89d="" className="sd">
                        <div data-s-954995ba-03f4-437e-9af7-b317ffae1e1c="" className="sd">
                          <div data-s-602eceea-5e07-4eb5-8c93-7095e3075e20="" className="sd">
                            <div data-s-d9111423-1a1f-4560-a8ad-2fc2c9c5fcae="" className="sd">
                              <a target="_blank" href="https://github.com/avcdsld/sakutaro-poem-nft" rel="noreferrer">
                                <p
                                  data-s-06d1fee6-0add-4293-8c06-e5d7a7446f13=""
                                  data-r-0_0_0_0_0_2_0_8_0_06d1fee6-0add-4293-8c06-e5d7a7446f13=""
                                  className="text sd"
                                >
                                  GitHub
                                </p>
                              </a>
                            </div>
                          </div>
                          <a
                            target="_blank"
                            href="https://github.com/avcdsld/sakutaro-poem-nft"
                            rel="noopener noreferrer"
                            data-s-218d2ad5-a96d-478b-b0fe-9a5139386091=""
                            className="icon fa fa-github sd"
                          >
                            {""}
                          </a>
                        </div>
                      </div>
                    </div>

                    <p
                      data-s-cd14a1d9-f90e-45a6-a004-d7a9748bb745=""
                      data-r-3_0_8_0_cd14a1d9-f90e-45a6-a004-d7a9748bb745=""
                      className="text sd"
                    >
                      If you have any questions, please contact me via Twitter.
                    </p>
                  </div>
                  <a id="backtothetop" href="/en#top" data-s-d4744538-8eb1-46ef-a405-8aa68db4740d="" className="sd">
                    <div
                      data-s-25ae5dbb-55f9-4ff2-9496-3872f08a5bab=""
                      data-r-0_1_8_0_25ae5dbb-55f9-4ff2-9496-3872f08a5bab=""
                      className="image sd"
                    ></div>
                    <p
                      data-s-757c4163-dfda-4d03-90fe-4cf3a1e16b82=""
                      data-r-1_1_8_0_757c4163-dfda-4d03-90fe-4cf3a1e16b82=""
                      className="text sd"
                    >
                      Back to the top
                    </p>
                  </a>
                </footer>
              </article>
              <header data-s-f2c38d51-0044-4d81-9b03-0adb6897363c="" className="fixed sd">
                <a
                  href="https://sakutaro-poem-nft.studio.site/#header"
                  data-s-267b3672-0044-47b4-acd9-ba08ab8e83e9=""
                  data-r-0_1_267b3672-0044-47b4-acd9-ba08ab8e83e9=""
                  className="text sd"
                >
                  SAKUTARO
                  <br />
                  Poem NFT
                </a>
              </header>
            </div>
            <div data-v-433e456e="" className="publish-studio-style"></div>
            <div data-v-4379ee28="" className="product-font-style"></div>
          </div>
          <div data-v-1dfadbfa="" className="Integrations"></div>
        </div>
      </div>
    </div>
  );
};
